import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { SuspendedFailedRecordsSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportSuspendedFailedRecords, sortSuspendedFailedRecords } from '../../constants';
import { searchDetailRecords, searchAllDetailRecords, onResetDefaultData } from '../../actions';
import { makeGetListDetailRecords, makeGetListAllDetailRecords } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class SuspendedFailedRecords extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss'),
      ratingType: 'POSTPAID',
    },
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listSuspendedFailedRecords: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listSuspendedFailedRecords: props.listSuspendedFailedRecords,
      totalCount: getPageTotalCount({ ...state, items: props.listSuspendedFailedRecords }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetDetailRecords },
      onResetDefaultData,
    } = this.props;
    if (modeGetDetailRecords) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listDetailRecords');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListSuspendedFailedRecords();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListSuspendedFailedRecords());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListSuspendedFailedRecords());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListSuspendedFailedRecords();
    });
  };

  doGetListSuspendedFailedRecords = () => {
    const { filter, page, size, sorted } = this.state;
    const { searchDetailRecords } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortSuspendedFailedRecords[sorted.sortCol]
          ? sortSuspendedFailedRecords[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    searchDetailRecords(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistSuspendedFailedRecords = cb => {
    const { filter, sorted } = this.state;
    const { searchAllDetailRecords } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortSuspendedFailedRecords[sorted.sortCol][sorted.sortDir] : null,
    };
    searchAllDetailRecords(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistSuspendedFailedRecords(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllSuspendedFailedRecords, t } = this.props;
        convertJson2Pdf({
          data: listAllSuspendedFailedRecords,
          t,
          title: t('reportPage:sidebar.suspendedFailedRecords').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.suspendedFailedRecords')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistSuspendedFailedRecords(() => {
      const { listAllSuspendedFailedRecords, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_SUSPENDED_FAILED_RECORDS_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.suspendedFailedRecords')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.suspendedFailedRecords')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllSuspendedFailedRecords,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              direction: 'usageDirection',
              errorCode: 'errorCodeProcessService',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllSuspendedFailedRecords,
          t,
          title: t('reportPage:sidebar.suspendedFailedRecords').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.suspendedFailedRecords')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 3,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.suspendedFailedRecords')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('SUSPENDED_FAILED_RECORDS_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportSuspendedFailedRecords,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listSuspendedFailedRecords,
      emails,
      filter,
      sourceOptions,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllSuspendedFailedRecords,
      t,
      permissions: { modeGetDetailRecords, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetDetailRecords) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    // tableColumnsOutput = tabelColumnExportSuspendedFailedRecords || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.suspendedFailedRecords') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.suspendedFailedRecords')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <SuspendedFailedRecordsSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  defaultFilter={filter}
                  keyOptionInject="source"
                  optionsInject={sourceOptions}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.suspendedFailedRecords').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllSuspendedFailedRecords,
                          t,
                          title: t('reportPage:sidebar.suspendedFailedRecords').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.suspendedFailedRecords')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listSuspendedFailedRecords}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listSuspendedFailedRecords && listSuspendedFailedRecords.length ? listSuspendedFailedRecords : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

SuspendedFailedRecords.propTypes = {
  searchDetailRecords: PropTypes.func,
  searchAllDetailRecords: PropTypes.func,
  listAllSuspendedFailedRecords: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

SuspendedFailedRecords.defaultProps = {
  searchDetailRecords: () => {},
  searchAllDetailRecords: () => {},
  listAllSuspendedFailedRecords: [],
};

const mapStateToProps = createStructuredSelector({
  listSuspendedFailedRecords: makeGetListDetailRecords() || [],
  listAllSuspendedFailedRecords: makeGetListAllDetailRecords() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    searchDetailRecords,
    searchAllDetailRecords,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(SuspendedFailedRecords)
);
